import {
    CLOSE_PARTICIPANTS_PANE_MODAL,
    MODERATION_PANE_CLOSE,
    MODERATION_PANE_OPEN,
    OPEN_PARTICIPANTS_PANE_MODAL,
    PARTICIPANTS_PANE_CLOSE,
    PARTICIPANTS_PANE_OPEN
} from './actionTypes';

/**
 * Action to close the moderation pane.
 *
 * @returns {Object}
 */
export const closeModerationPane = () => {
    return {
        type: MODERATION_PANE_CLOSE
    };
};

/**
 * Action to open the moderation pane.
 *
 * @returns {Object}
 */
export const openModerationPane = () => {
    return {
        type: MODERATION_PANE_OPEN
    };
};

/**
 * Action to close the participants pane.
 *
 * @returns {Object}
 */
export const close = () => {
    return {
        type: PARTICIPANTS_PANE_CLOSE
    };
};

/**
 * Action to open the participants pane.
 *
 * @returns {Object}
 */
export const open = () => {
    return {
        type: PARTICIPANTS_PANE_OPEN
    };
};

/**
 * Displays the Participant Pane Modal.
 *
 *
 * @returns {{
*     type: OPEN_PARTICIPANTS_PANE_MODAL
* }}
*/
export function openParticipantsPaneModal() {
    return {
        type: OPEN_PARTICIPANTS_PANE_MODAL
    };
}

/**
* Displays the chat panel.
*
*
* @returns {{
*     type: CLOSE_PARTICIPANTS_PANE_MODAL
* }}
*/
export function closeParticipantsPaneModal() {
    return {
        type: CLOSE_PARTICIPANTS_PANE_MODAL
    };
}
